import {
  revdojoImg,
  misoRoboticsImg,
  broowingCoffeeImg,
  budgetMangrImg,
  letsTalkImg,
  peryaGamesImg,
  rpsImg,
  purinaImg,
  solaireImg
} from 'assets';
import {Project} from './types';

const projects: Array<Project> = [
  {
    src: purinaImg,
    name: 'Purina',
    url: 'https://www.purina.com/',
    content:
      'A global leader in science-based pet care and nutritional manufacturing built exclusively for the pet wellness industry with a website that features interactive food finder tools, an extensive cat and dog breed directory, and scientifically formulated dietary products.L.'
  },
  {
    src: solaireImg,
    name: 'Solaire Player360',
    url: 'https://player360.solaireresort.com/',
    content:
      'An internal customer relationship management (CRM) and database system used by Solaire Resort Entertainment City in Parañaque, Philippines.'
  },
  {
    src: revdojoImg,
    name: 'RevDojo',
    url: 'https://www.revdojo.com/',
    content:
      'An all-in-one business optimization and sales training platform built exclusively for the automotive dealership with a website designed to maximize dealership revenue through custom training modules, virtual learning management tools, and comprehensive automotive performance insights.'
  },
  {
    src: misoRoboticsImg,
    name: 'Miso Robotics',
    url: 'https://misorobotics.com/',
    content:
      'An AI-powered culinary automation platform designed for commercial and quick-service restaurants. Its flagship product, Flippy, is an autonomous robotic kitchen assistant that automates dangerous, repetitive, and hard-to-staff tasks, such as operating fry stations and grilling burgers.'
  },
  {
    src: letsTalkImg,
    name: "Let's Talk",
    url: 'https://lets-talk.com',
    content:
      "Let's Talk is web application where you can interact to other online users who you want to confess with or you may also be the samaritan where you can comfort others on their problems, the goal is to make unfortunate users to feel free to confess there problems and issues in life without knowing their real personality, this application is running on React JS, FastAPI, Websocket, and PostgreSQL."
  },
  {
    src: broowingCoffeeImg,
    name: 'Broowing Coffee',
    url: 'https://broowingcoffee.com/',
    content:
      "Broowing Coffee is a mobile web point of sale and inventory management with a real life design scenario, create product, include the inventory, create transaction with an e-receipt at the same time the deduction of inventory simultaneously, and yes it can also create reports depends on what user's specified date, this application runs in React JS, Expresss, NodeJS and MongoDB."
  },
  {
    src: peryaGamesImg,
    name: 'Perya Games',
    url: 'https://play.google.com/store/apps/details?id=com.vbasement.peryagames/',
    content:
      'Perya Games is a mobile game application where you can play and earn money, it has multiple games where you can play like, Color Game, Slot Machine etc. the transaction for deposit and withdraw are handled by content management system, and the tech stack that are React Native, Pyton Flask and PostgreSQL.'
  },
  {
    src: budgetMangrImg,
    name: 'Budget Manager',
    url: 'https://budget-mngr.com/',
    content:
      'Budget Manager is a mobile web application that helps you to manage your budget plans, where you can put your estimated capital for the budget and by adding expenses it creates a log and computation in the system, the system is powered by React JS, Python Flask and PostgreSQL.'
  },
  {
    src: rpsImg,
    name: 'Rock Paper Scissor',
    url: 'https://play.google.com/store/apps/details?id=com.mv.rockpaperscissor/',
    content:
      'Rock Paper Scissor is a multiplayer mobile online game, where the player should pick their battle hand within 5 seconds, the player who will win got 5 crown points, the purpose of this project is to make you bonding with your friends or family, its Tech Stack is MERN composed of MongoDB, Express, React Native and Node JS, this is the first game that I made in my college just for fun and make myself known about fullstack environment.'
  }
];

export default projects;
